import { Module } from "vuex";
import { ISalesState } from "@/core/interfaces/salesState.interface";
import { StoreState } from "@/store/type";

import mutations from "./mutations";
import actions from "./actions";
import state from "./state";
import getters from "./getters";

const salesModule: Module<ISalesState, StoreState> = {
  state,
  mutations,
  actions,
  getters,
};

export default salesModule;
